import { h } from 'preact';
import Container from '../';

export const ContainerFluid = (props) => {
	let { children } = props;

	return (
		<Container baseClass="container-fluid" class={props.class} {...props}>
			{children}
		</Container>

	);
};

export default ContainerFluid;
